export type DeviceType = 'ANDROID' | 'IOS' | 'WEB';

const DEVICE_ID_KEY = 'deviceId';
const DEVICE_TOKEN_KEY = 'deviceToken';

export const getOrCreateDeviceId = (): string => {
  const existing = localStorage.getItem(DEVICE_ID_KEY);
  if (existing) return existing;
  const random = Math.random().toString(36).slice(2);
  const newId = `web_${Date.now()}_${random}`;
  localStorage.setItem(DEVICE_ID_KEY, newId);
  return newId;
};

export const getDeviceType = (): DeviceType => {
  const ua = (navigator?.userAgent || '').toLowerCase();
  if (/android/.test(ua)) return 'ANDROID';
  if (/iphone|ipad|ipod|ios/.test(ua)) return 'IOS';
  return 'WEB';
};

export const getStoredDeviceToken = (): string | null => {
  return localStorage.getItem(DEVICE_TOKEN_KEY);
};

export const storeDeviceToken = (token: string): void => {
  localStorage.setItem(DEVICE_TOKEN_KEY, token);
};

export const resolveDeviceToken = (): string => {
  // Prefer explicitly stored token key(s)
  const known =
    localStorage.getItem('fcmDeviceToken') ||
    localStorage.getItem(DEVICE_TOKEN_KEY);
  if (known && known.length > 0) return known;
  // Fallback: use deviceId so backend still receives a stable identifier
  return getOrCreateDeviceId();
};
